import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = () => {
  const location = useLocation();

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);

  const breadcrumbMap = {
    'feed': { label: '피드', labelEn: 'Feed' },
    'feed-detail': { label: '피드 상세', labelEn: 'Feed Detail' },
    'feed-editor': { label: '피드 작성', labelEn: 'Feed Editor' },
    'project-dashboard': { label: '목표 관리', labelEn: 'Projects' },
    'project-detail': { label: '목표 상세', labelEn: 'Project Detail' },
    'challenge-detail': { label: '챌린지 상세', labelEn: 'Challenge Detail' },
    'proof-submission': { label: '인증 제출', labelEn: 'Proof Submission' },
    'proof-detail-view': { label: '인증 상세', labelEn: 'Proof Detail' },
    'challenge-creation': { label: '챌린지 생성', labelEn: 'Create Challenge' },
    'user-profile-dashboard': { label: '프로필', labelEn: 'Profile' },
    'admin-dashboard': { label: '관리자', labelEn: 'Admin' },
  };

  const breadcrumbs = [
    { label: '홈', labelEn: 'Home', path: '/project-dashboard' },
    ...pathSegments?.map((segment, index) => {
      const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
      const breadcrumbInfo = breadcrumbMap?.[segment] || {
        label: segment,
        labelEn: segment,
      };
      return {
        label: breadcrumbInfo?.label,
        labelEn: breadcrumbInfo?.labelEn,
        path: path,
      };
    }),
  ];

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav
      className="sticky top-16 z-[999] bg-background border-b border-border px-4 lg:px-8 py-3"
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center space-x-2 max-w-screen-2xl mx-auto overflow-x-auto">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          const isFirst = index === 0;

          if (index > 0 && index < breadcrumbs?.length - 1 && breadcrumbs?.length > 3) {
            if (index === 1) {
              return (
                <li key={`${crumb?.path}-${index}`} className="hidden lg:flex items-center space-x-2">
                  <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-muted-foreground">...</span>
                </li>
              );
            }
            return null;
          }

          return (
            <li key={`${crumb?.path}-${index}`} className="flex items-center space-x-2">
              {!isFirst && (
                <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
              )}
              {isLast ? (
                <span className="text-sm font-medium text-foreground caption">
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="text-sm text-muted-foreground hover:text-foreground transition-gaming caption"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;